import React from 'react';
import PropTypes from 'prop-types';

import { useIntl } from 'react-intl';
import { connect } from 'react-redux';

import { attributeTypeEnum, attributePresentationTypeEnum } from '../../../../enums/attributes';
import { generateDropDownOptionsForEnum } from '../../../../utils/components';
import { generateCategoryDropdownOptions } from '../../../../utils/categories';
import { selectTranslatedFlattenedCategoryTree } from '../../../../redux/selectors/categories';

import SearchForm from '../../../../components/generators/SearchForm';

const propTypes = {
    performFeatureSearch: PropTypes.func,
    searchConfig: PropTypes.object.isRequired,
};

const FeatureSearchForm = ({ performFeatureSearch, categories, searchConfig }) => {
    const intl = useIntl();
    const translations = intl.messages.features.searchForm;

    const typeOptions = generateDropDownOptionsForEnum(attributeTypeEnum, translations.filters.attributeType);
    const presentationOptions = generateDropDownOptionsForEnum(attributePresentationTypeEnum, translations.filters.attributePresentation);

    const onSubmit = formData => {
        performFeatureSearch(formData);
    };

    return (
        <SearchForm
            searchConfig={searchConfig}
            performSearch={onSubmit}
            translations={{
                buttons: {
                    submit: translations.action,
                    reset: translations.reset,
                }
            }}
            inputs={[
                {
                    type: 'text',
                    label: translations.phrase.label,
                    name: 'attributeName'
                },
                {
                    type: 'dropdown',
                    label: translations.type.label,
                    name: 'attributeType',
                    options: typeOptions,
                    defaultLabel: translations.type.placeholder
                },
                {
                    type: 'dropdown',
                    label: translations.presentation.label,
                    name: 'attributePresentation',
                    options: presentationOptions,
                    defaultLabel: translations.presentation.placeholder
                },
                {
                    type: 'dropdown',
                    label: translations.category.label,
                    name: 'categoryId',
                    options: generateCategoryDropdownOptions(categories, translations.category.placeholder),
                    defaultLabel: translations.category.placeholder
                },
            ]}
        />
    );
};

FeatureSearchForm.propTypes = propTypes;

const mapStateToProps = state => ({
    categories: selectTranslatedFlattenedCategoryTree(state),
});

const mapDispatch = {

};

export default connect(mapStateToProps, mapDispatch)(FeatureSearchForm);